module.exports = __webpack_public_path__ + "static/img/FJ.578ba249.svg";